import { render, staticRenderFns } from "./IncomingRegulation.vue?vue&type=template&id=e53e446c&scoped=true&"
import script from "./IncomingRegulation.vue?vue&type=script&lang=js&"
export * from "./IncomingRegulation.vue?vue&type=script&lang=js&"
import style0 from "./IncomingRegulation.vue?vue&type=style&index=0&id=e53e446c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53e446c",
  null
  
)

export default component.exports